import { useEffect, useRef } from "react";
export function useDidUpdateEffect(fn, inputs) {
    const started = useRef(true);
    useEffect(() => {
        if (!started.current) {
            // this is called subsequently
            return fn();
        }
        else {
            // this is initially called
            started.current = false;
        }
    }, inputs);
}
//# sourceMappingURL=use-did-update-effect.js.map